<svg xmlns="http://www.w3.org/2000/svg" xmlns:svg="http://www.w3.org/2000/svg"
  viewBox="0 0 128 128"
  width="128"
  height="128">
 <g>

  <path
    opacity="0.7"
    fill="currentColor"
    stroke="none"
    d="
      M 16 3 L 112 3
      A 13 13 90 0 1 125 16
      L 125 32
      L 3 32
      L 3 16
      A 13 13 90 0 1 16 3
      "
  />

  <path
    opacity="0.3"
    fill="none"
    stroke="currentColor"
    stroke-width="18"
    d="
      M 0 60 L 128 60
      M 0 96 L 128 96
    "
  />

    <path
    opacity="0.3"
    fill="none"
    stroke="currentColor"
    stroke-width="6"
    d="
      M 54 32 L 54 51
      M 90 32 L 90 51

      M 54 69 L 54 87
      M 90 69 L 90 87

      M 54 105 L 54 128
      M 90 105 L 90 128
    "
  />

  <path
    fill="none"
    stroke="currentColor"
    stroke-width="6"
    d="
      M 16 3 L 112 3
      A 13 13 90 0 1 125 16
      L 125 112
      A 13 13 90 0 1 112 125
      L 16 125
      A 13 13 90 0 1 3 112
      L 3 16
      A 13 13 90 0 1 16 3
      "
  />
 </g>
</svg>